<template>
  <div :class="modalClass">
    <div class="content" @modal-close="toggleModal(name)">
      <span class="close" @click="toggleModal(name)">X</span>
      <h4 style="text-align: center">Add Roommate</h4>
      <br />
      <div class="field">
        <label class="tinylabel"> First Name <red v-pre>*</red> </label>
        <input v-model="user.firstName" type="text" />
      </div>
      <br />
      <div class="field">
        <label class="tinylabel"> Last Name <red v-pre>*</red> </label>
        <input v-model="user.lastName" type="text" />
      </div>
      <br /><br /><br />
      <div style="text-align: center">
        <button :disabled="!validated" @click="addUser()">Add</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { InsuranceUser } from "@/models/InsuranceUser";
import { onMounted, ref, computed, onUnmounted } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import useModal from "@/hooks/useModal";
import { storeToRefs } from "pinia";

const props = defineProps({
  name: {
    type: String,
    default: "",
  },
});
const { toggleModal, onModalMounted, onModalDestroy } = useModal();
const modalClass = onModalMounted(props.name);
const user = ref(new InsuranceUser());
const quote = useQuoteStore();

onMounted(() => {
  user.value = new InsuranceUser();
});

onUnmounted(() => {
  onModalDestroy(props.name);
});

function addUser() {
  quote.checkout.roommates.push(user.value);
  toggleModal(props.name);
  user.value = new InsuranceUser();
}

function onShow() {
  // Reset user on new show
  user.value = new InsuranceUser();
}

const validated = computed(() => {
  return user.value.firstName && user.value.lastName;
});
</script>
<style scoped>
.content {
  max-width: 400px !important;
}
</style>
